export const ordersKeys = {
  all: ['orders'] as const,
  list: (params: Record<string, unknown>) => [...ordersKeys.all, 'list', params] as const,
  detail: (idOrNumber: string | undefined) =>
    [...ordersKeys.all, 'detail', idOrNumber ?? ''] as const,
  summary: (params?: { storeId?: string }) =>
    [...ordersKeys.all, 'summary', params as { storeId?: string }] as const,
  warehouses: () => [...ordersKeys.all, 'warehouses'] as const,
  overview: () => [...ordersKeys.all, 'overview'] as const,
};
